import { render, staticRenderFns } from "./WrsViWeekDate.vue?vue&type=template&id=a5d8aac6&"
import script from "./WrsViWeekDate.vue?vue&type=script&lang=js&"
export * from "./WrsViWeekDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports